import React from 'react';

import { Checkbox, ICheckboxProps } from '@rbilabs/components-library';
import { FieldProps } from 'formik';

export const FormikCheckbox: React.FC<FieldProps & ICheckboxProps> = ({
  form,
  field,
  ...props
}) => {
  const { name } = field;
  const checked = !!form.values[name];
  const errorMessage =
    form.errors[name] && form.touched[name] ? (form.errors[name] as string) : undefined;
  return <Checkbox {...field} {...props} checked={checked} errorMessage={errorMessage} />;
};
